import {
  jb_region_select_overlay_css_default
} from "./chunk.OYB5B6SX.js";
import {
  JbI18nData
} from "./chunk.7MK6IR25.js";
import {
  Linkable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.3FKBYJ4V.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Animatable
} from "./chunk.JXPX63WS.js";
import {
  JBCookie
} from "./chunk.NKAUZW5M.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  e,
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-region-select-overlay/jb-region-select-overlay.ts
var JbRegionSelectOverlay = class extends Initiable(Linkable(Animatable(r))) {
  constructor() {
    super(...arguments);
    this._alert = "";
    this._countries = [];
    this._countryDisabled = false;
    this._languageDisabled = false;
    this._languages = [];
    this._link = "";
    this._regionDisabled = false;
    this._regions = [];
    this._selectedCountry = JBCookie.getI18nCookieData().country;
    this._selectedLanguage = JBCookie.getI18nCookieData().language;
    this._selectedLanguageIso2 = JBCookie.getI18nCookieData().languageIso2;
    this._selectedMarket = JBCookie.getI18nCookieData().market;
    this._selectedRegion = JBCookie.getI18nCookieData().region || "0";
  }
  firstUpdated() {
    this._loadAllRegions();
    this._loadCountriesForRegion();
    this.addEventListener("jb-select:changed", (event) => {
      const eventDetail = event.detail;
      if (eventDetail.id === "region" && eventDetail.newValue) {
        this._selectedRegion = eventDetail.newValue;
        this._loadCountriesForRegion();
      }
      if (eventDetail.id === "country" && eventDetail.newValue) {
        this._selectedCountry = eventDetail.newValue;
        this._selectedMarket = this._countries.find((country) => country.value === eventDetail.newValue)?.market.toString();
        this._loadLanguagesForCountry();
      }
      if (eventDetail.id === "language" && eventDetail.newValue) {
        this._selectedLanguageIso2 = eventDetail.newValue;
        const languageUid = this._languages.find((language) => language.value === eventDetail.newValue)?.uid;
        this._selectedLanguage = languageUid ? languageUid.toString() : "0";
        this._link = this._languages.find((language) => language.value === eventDetail.newValue)?.url;
      }
    });
  }
  _fireTrackingEvent(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "header",
      interaction_effect: "update_location",
      interaction_element: "location-selector",
      interaction_text: `location-selector__region:${this._selectedRegion}|country:${this._selectedCountry.toLowerCase()}|language:${this._selectedLanguage}`
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _loadAllRegions() {
    const regions = JbI18nData.find()?.getI18nDataRegions();
    if (!regions) {
      return;
    }
    regions.map(
      (region) => this._regions.push({
        label: region.label,
        value: region.regionUid.toString(),
        countries: region.countries,
        regionUid: region.regionUid
      })
    );
  }
  _loadCountriesForRegion() {
    const countries = JbI18nData.find()?.getI18nDataCountriesForRegion(this._selectedRegion);
    this._countries = [];
    if (!countries) {
      return;
    }
    countries.map(
      (country) => this._countries.push({
        label: country.label,
        value: country.countryIsoCode.toString(),
        countryIsoCode: country.countryIsoCode.toString(),
        languageOptions: country.languageOptions,
        market: country.market
      })
    );
    this._countryDisabled = countries.length <= 1;
    if (this._countries.length === 1) {
      this._selectedCountry = this._countries[0].value;
    }
  }
  _loadLanguagesForCountry() {
    const i18nDataComponent = JbI18nData.find();
    if (!i18nDataComponent) {
      return;
    }
    const languageOptions = i18nDataComponent.getI18nDataLanguageOptionsForCountry(this._selectedCountry);
    this._languages = [];
    if (!languageOptions) {
      return;
    }
    let foundLanguage;
    languageOptions.forEach((languageOption) => {
      const language = i18nDataComponent.getLanguageByIsoCode(languageOption.language);
      if (language?.languageIsoCode === JBCookie.getI18nCookieData().languageIso2) {
        foundLanguage = JBCookie.getI18nCookieData().languageIso2;
      }
      if (!language) {
        return;
      }
      this._languages.push({
        label: language.label,
        value: language.languageIsoCode.toString(),
        uid: language.languageUid,
        url: languageOption.url,
        languageData: language
      });
      if (languageOption.marketAlert?.body) {
        this._alert = languageOption.marketAlert.body;
      } else {
        this._alert = "";
      }
    });
    const newLanguage = foundLanguage ?? this._languages[0]?.value;
    if (newLanguage !== "") {
      setTimeout(() => {
        this._languageSelect.setValue(newLanguage);
        this._selectedLanguageIso2 = newLanguage;
        this._selectedLanguage = this._languages.find((language) => language.value === newLanguage)?.uid.toString() || "0";
        this._link = this._languages.find((language) => language.value === newLanguage)?.url;
      }, 10);
    }
    this._languageDisabled = languageOptions.length <= 1;
  }
  _setCookieAndGAData(e2) {
    this._fireTrackingEvent(e2);
    const newCookieData = {
      country: this._selectedCountry,
      language: this._selectedLanguage,
      languageIso2: this._selectedLanguageIso2,
      market: this._selectedMarket || "",
      region: this._selectedRegion
    };
    JBCookie.setI18nCookieData(newCookieData);
  }
  render() {
    return ke`
      <div class="region-select-overlay">
        <div
          class="region-select-overlay__scroll-wrap"
          data-scroll-lock-scrollable
        >
          <div class="region-select-overlay__wrap">
            <div class="region-select-overlay__text">${this.text}</div>
            <jb-select
              id="region"
              .ariaLabels=${{ label: this.ariaLabels?.region }}
              .label=${this.regionLabel}
              .options=${this._regions}
              .value=${this._selectedRegion}
              .disabled=${this._regionDisabled}
              type="isregionselect"
              showLabel
            ></jb-select>
            <jb-select
              id="country"
              .ariaLabels=${{ label: this.ariaLabels?.country }}
              .label=${this.countryLabel}
              .options=${this._countries}
              .value=${this._selectedCountry}
              .disabled=${this._countryDisabled}
              type="isregionselect"
              showLabel
            ></jb-select>
            <jb-select
              id="language"
              .ariaLabels=${{ label: this.ariaLabels?.language }}
              .label=${this.languageLabel}
              .options=${this._languages}
              .value=${this._selectedLanguageIso2}
              .disabled=${this._languageDisabled}
              type="isregionselect"
              showLabel
            ></jb-select>
            <slot></slot>
            ${this._alert ? ke`
                  <div class="region-select-overlay__text region-select-overlay__notification">
                    <p>${this._alert}</p>
                  </div>
                ` : ""}
            <jb-button-primary
              @jb-link:clicked=${this._setCookieAndGAData}
              .link=${{ href: this._link }}
              inverted
              >${this.buttonText}</jb-button-primary
            >
          </div>
        </div>
      </div>
    `;
  }
};
JbRegionSelectOverlay.styles = [reset_css_default, jb_region_select_overlay_css_default];
__decorateClass([
  n({ type: Object })
], JbRegionSelectOverlay.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbRegionSelectOverlay.prototype, "buttonText", 2);
__decorateClass([
  n()
], JbRegionSelectOverlay.prototype, "countryLabel", 2);
__decorateClass([
  n()
], JbRegionSelectOverlay.prototype, "languageLabel", 2);
__decorateClass([
  n()
], JbRegionSelectOverlay.prototype, "regionLabel", 2);
__decorateClass([
  n()
], JbRegionSelectOverlay.prototype, "text", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_alert", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_countries", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_countryDisabled", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_languageDisabled", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_languages", 2);
__decorateClass([
  e("#language")
], JbRegionSelectOverlay.prototype, "_languageSelect", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_link", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_regionDisabled", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_regions", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_selectedCountry", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_selectedLanguage", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_selectedLanguageIso2", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_selectedMarket", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_selectedRegion", 2);
JbRegionSelectOverlay = __decorateClass([
  customElement("jb-region-select-overlay")
], JbRegionSelectOverlay);

export {
  JbRegionSelectOverlay
};
